import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Season } from '@coin/shared/season-mgmt/util';
import { SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { SeasonPlan } from '@coin/shared/core/util-models';
import { Observable } from 'rxjs';
import { SeasonState } from '../../../season-mgmt/store';

interface DialogData {
  showDescription: boolean;
  descriptionLabel?: string;
  label?: string;
}

@Component({
  selector: 'admin-app-add-plan',
  templateUrl: './add-plan.component.html',
  styleUrls: ['./add-plan.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddPlanComponent implements OnInit {
  private seasonState = inject(SeasonState);
  private dialogRef = inject<MatDialogRef<AddPlanComponent>>(MatDialogRef);
  data = inject<DialogData>(MAT_DIALOG_DATA);

  plan: SeasonPlan = {
    title: ''
  };

  private season: Season;

  public static openDialog(dialog: MatDialog, data?: DialogData): Observable<SeasonPlan> {
    return dialog
      .open<AddPlanComponent, DialogData, SeasonPlan>(AddPlanComponent, {
        disableClose: true,
        minWidth: '500px',
        data
      })
      .beforeClosed();
  }

  ngOnInit(): void {
    this.season = this.seasonState.currentSeason();
  }

  public get showDisplayName(): boolean {
    return this.season?.seasonType === SeasonTypeEnum.IncentiveV2;
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public addPlan(): void {
    this.dialogRef.close(this.plan);
  }

  public get inputInvalid(): boolean {
    const validTitle = this.plan.title?.replace(/\s+/g, '');
    return !validTitle;
  }
}
